<footer class="c-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center"><a class="c-footer__logo"  title="Logo"><img src="../assets/img/logo.svg" alt="Logo BHP"></a></div>
      </div>
    </div>
  </footer>